<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="custFolderCode"
      resizable
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      show-overflow
      :tree-config="{ children: 'folders', expandAll: true, trigger: 'row' }"
      :radio-config="{ highlight: true }"
      @radio-change="radioChange"
    >
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    custFolderCode: { type: String, default: '' },
    parentCode: { type: String, default: '' },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      tableColumns: [
        {
          field: 'radio',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'radio',
        },
        {
          title: this.$l('table_title_custFolderName') || '文件夹名称',
          field: 'custFolderName',
          minwidth: 130,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
          treeNode: true,
        },
        {
          title: this.$l('table_title_custFolderDesc') || '文件夹说明',
          field: 'custFolderDesc',
          minwidth: 130,
          headerAlign: 'center',
          align: 'left',
          showHeaderOverflow: true,
        },
      ],
      checkFolder: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .masterCustomerFolderTreeApi({ custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      const data = res?.body?.data || []
      this.tableData = this._filter(data)

      setTimeout(() => {
        this.setRadioRow(this.parentCode)
      }, 0)
    },
    _filter(data) {
      if (!data?.length) return []

      return data
        .map((row) => {
          const { folders, ...item } = row
          if (item.custFolderCode === this.custFolderCode) return false
          return { ...item, folders: this._filter(folders) }
        })
        .filter(Boolean)
    },
    radioChange({ row }) {
      this.checkFolder = row
    },
    setRadioRow(key) {
      const $table = this.$refs.table
      const row = $table.getRowById(key)
      this.checkFolder = row
      if (row) $table.setRadioRow(row)
    },
    async confirm() {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_moveFolder') || '是否将文件夹移至该目录吗？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .masterCustomerFolderChangeParentApi({
          custFolderCode: this.custFolderCode,
          parentCode: this.checkFolder.custFolderCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('close')
    },
  },
}
</script>
